import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LOCALES } from '../../constants/intl';
import { Messages } from '../../types';

interface IntlLocaleData {
  locale: string;
  messages: Messages;
}

interface IntlState {
  readonly currentLocale: LOCALES;
  readonly localeData: Record<string, IntlLocaleData>;
}

const initialState: IntlState = {
  currentLocale: LOCALES.EN,
  localeData: { en: { locale: LOCALES.EN, messages: {} as Messages } },
};

const intlSlice = createSlice({
  name: 'intl',
  initialState,
  reducers: {
    loadMessages(state, { payload }: PayloadAction<IntlLocaleData>) {
      state.localeData[payload.locale] = payload;
    },
    switchLocale(state, { payload }: PayloadAction<LOCALES>) {
      state.currentLocale = payload;
    },
  },
});

export const intlReducer = intlSlice.reducer;

export default intlSlice.actions;
